import angular from 'angular';

module.exports = angular.module('common.directives.image-background', [])
.directive('imageBackground', function (imageUrlFilter) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      let imageUrl = imageUrlFilter(attrs.imageBackground);
      element.css({ 'background-image': `url(${imageUrl})` });
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/image-background.js
 **/